module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-top-stone-path-remnants.72fec700.png";